import React from 'react';
import { styled } from '@compiled/react';
import { Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import linkMessages from '../../messages/link-messages.tsx';

type Props = {
	intl: IntlShape;
	id?: string;
};

const ProTip = (props: Props) => {
	const {
		intl: { formatMessage },
		id,
	} = props;
	const label = formatMessage(linkMessages.proTipLabel);
	const message = formatMessage(linkMessages.proTipMessage);
	return (
		<ProTipWrapper id={id}>
			<Text as="strong" size="small" color="color.text.subtle">
				{label}&nbsp;<Text size="small">{message}</Text>
			</Text>
		</ProTipWrapper>
	);
};

export default injectIntl(ProTip);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ProTipWrapper = styled.small({
	marginTop: token('space.200'),
});
